import _ from "lodash";
import React, { ReactElement, useMemo, useState } from "react";
import Select from "react-select";
import { Loading } from "../ui";
import { Project } from "./Project";
import { ProjectService } from "./ProjectService";

interface IProps {
	accountId: string;
	handleChange: (selectedProjects: any, actionType: any) => any;
	defaultValue: any;
	isMulti?: boolean;
	returnModels?: boolean;
}

export const ProjectsForAccountSelect = (props: IProps): ReactElement => {
	const [projects, setProjects] = useState<Project[]>();

	const projectService = new ProjectService();

	useMemo(() => {
		const fetchProjects = async () => {
			const opportunityData = await projectService.findByAccount(
				props.accountId,
			);
			setProjects(opportunityData);
		};

		fetchProjects();
	}, []);

	if (!projects) {
		return <Loading />;
	}

	if (projects.length === 0) {
		return <span>No Projects Available </span>;
	}

	const options = projects.map((project: Project) => {
		return {
			value: project.id,
			label: project.name,
		};
	});

	return (
		<Select
			{...props}
			options={options}
			onChange={(selectedOpportunity: any, actionType: any) => {
				let selected = selectedOpportunity;
				if (props.returnModels) {
					if (props.isMulti) {
						const projectIds = selected.map((proj: any) => {
							return proj.value;
						});
						selected = projects.filter((proj: Project) => {
							return _.includes(projectIds, proj.id);
						});
					} else {
						selected = projects.filter((proj: Project) => {
							return selected.value === proj.id;
						})[0];
					}
				}

				props.handleChange(selected, actionType);
			}}
		/>
	);
};
